<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-video4-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-video4-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.88955947639175;"
    data-aspect-ratio="0.89"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-video4-xs-img"
      class="g-video4-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.9976%;margin-top:-8.5px;left:72.4982%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:31.2912%;margin-top:-9.1px;right:24.401%;width:133px;"
    >
      <p class="g-pstyle1">Moves wheel right</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-boxtext g-aiAbs"
      style="top:79.2517%;left:49.8553%;margin-left:-25.303%;width:50.6061%;"
    >
      <p class="g-pstyle2">Good turns wheel right.</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-video4-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.37469387239591;"
    data-aspect-ratio="1.375"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-video4-sm-img"
      class="g-video4-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.9973%;margin-top:-8.5px;left:64.5577%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:31.2894%;margin-top:-9.1px;right:33.436%;width:133px;"
    >
      <p class="g-pstyle1">Moves wheel right</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-boxtext g-aiAbs"
      style="top:79.2471%;left:49.9064%;margin-left:-16.3725%;width:32.7451%;"
    >
      <p class="g-pstyle2">Good turns wheel right.</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-video4-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.77891225836617;"
    data-aspect-ratio="1.779"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-video4-md-img"
      class="g-video4-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.7498%;margin-top:-9.6px;left:60.3643%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:31.0404%;margin-top:-10.2px;right:37.1729%;width:149px;"
    >
      <p class="g-pstyle1">Moves wheel right</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-boxtext g-aiAbs"
      style="top:79.2425%;left:49.9276%;margin-left:-12.6515%;width:25.303%;"
    >
      <p class="g-pstyle2">Good turns wheel right.</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-video4-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 2.50635790777582;"
    data-aspect-ratio="2.506"
    data-min-width="930"
  >
    <div
      id="g-video4-lg-img"
      class="g-video4-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/video4-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:4.7493%;margin-top:-9.6px;left:58.2155%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle0">00:13</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:31.0368%;margin-top:-10.2px;right:40.8969%;width:149px;"
    >
      <p class="g-pstyle1">Moves wheel right</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-boxtext g-aiAbs"
      style="top:79.2332%;left:49.9487%;margin-left:-8.9785%;width:17.957%;"
    >
      <p class="g-pstyle2">Good turns wheel right.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-09 16:40 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-09 16:40 -->
<!-- ai file: video4.ai -->
<style lang="scss">
  #g-video4-box {
    container-type: inline-size;
    container-name: g-video4-box;
  }
  #g-video4-box,
  #g-video4-box .g-artboard {
    margin: 0 auto;
  }
  #g-video4-box p {
    margin: 0;
  }
  #g-video4-box .g-aiAbs {
    position: absolute;
  }
  #g-video4-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-video4-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-video4-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-video4-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-video4-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-video4-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-video4-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-video4-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-video4-lg {
        display: block !important;
      }
    }
  }
  #g-video4-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-video4-xs .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(191, 226, 45);
  }
  #g-video4-xs .g-pstyle2 {
    font-weight: 700;
    text-align: center;
  }
  #g-video4-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-video4-sm .g-pstyle1 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(191, 226, 45);
  }
  #g-video4-sm .g-pstyle2 {
    font-weight: 700;
    text-align: center;
  }
  #g-video4-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-video4-md .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: right;
    color: rgb(191, 226, 45);
  }
  #g-video4-md .g-pstyle2 {
    font-weight: 700;
    text-align: center;
  }
  #g-video4-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-video4-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-video4-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-video4-lg .g-pstyle1 {
    font-weight: 700;
    height: 19px;
    text-align: right;
    color: rgb(191, 226, 45);
  }
  #g-video4-lg .g-pstyle2 {
    font-weight: 700;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
